import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import authProvider from '../../../../core/AuthenticationProvider'
import {
  FORMAT,
  getCurrentDateTime,
  getDiffTime,
} from '../../../helpers/datetime'
import { localStorageKeys } from '../../../utils/common'
import { UseTimeZone } from '../../hooks/useTimeZone'
import { Element } from '../../html/element'
import { Image } from '../../image'
import countDownGif from './countDown.gif'
import classes from './CountDown.module.scss'

const COUNT_DOWN = 30 // seconds

export const CountDown = ({ parentRef, removeIntervalAndTimeOut }) => {
  const [count, setCount] = useState(COUNT_DOWN)
  const locale = useSelector((state) => state.i18n.locale)
  const timeZone = UseTimeZone()

  useEffect(() => {
    parentRef.current.timeOut = setTimeout(() => {
      removeIntervalAndTimeOut()
      authProvider.signout()
    }, (COUNT_DOWN + 1) * 1000)

    localStorage.setItem(
      localStorageKeys.KEY_START_TIME_SESSION_EXPIRED,
      getCurrentDateTime(FORMAT.DATE_TIME, locale, timeZone),
    )
    parentRef.current.interval = setInterval(() => {
      setCount((count) => Math.max(count - 1, 0))
    }, 1000)

    return () => {
      removeIntervalAndTimeOut()
    }
  }, [])

  useEffect(() => {
    const visibilitychange = () => {
      const currentTime = localStorage.getItem(
        localStorageKeys.KEY_START_TIME_SESSION_EXPIRED,
      )
      if (currentTime) {
        const diffTime = getDiffTime(
          currentTime,
          getCurrentDateTime(FORMAT.DATE_TIME, locale, timeZone),
        )
        if (diffTime >= 0 && diffTime < COUNT_DOWN) {
          setCount(COUNT_DOWN - diffTime)
        } else {
          removeIntervalAndTimeOut()
          authProvider.signout()
        }
      }
    }
    document.addEventListener('visibilitychange', visibilitychange)
    return () => {
      document.removeEventListener('visibilitychange', visibilitychange)
    }
  }, [])

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <Image src={countDownGif} style={{ width: 128, height: 128 }} />
        <Element
          elementName="span"
          className={classes.label}
          style={{ color: '#0553A5', fontSize: 24 }}
        >
          {count}
        </Element>
      </div>
    </div>
  )
}

CountDown.propTypes = {
  parentRef: PropTypes.object.isRequired,
  removeIntervalAndTimeOut: PropTypes.func.isRequired,
}
